import { request } from "./apiClient";

type AccountNamesResponse = { names: string[] };

export async function fetchAccountNames(): Promise<string[]> {
  const res = await request<AccountNamesResponse>("/users/me/account-names");
  return res.names;
}

export async function updateAccountNames(names: string[]): Promise<string[]> {
  const res = await request<AccountNamesResponse>("/users/me/account-names", {
    method: "PUT",
    data: { names },
  });
  return res.names;
}

export interface BillDisplayName {
  /** Custom name friends see; null → falls back to the account name. */
  name: string | null;
  fallback: string;
}

export const fetchBillDisplayName = () =>
  request<BillDisplayName>("/users/me/bill-display-name");

export const updateBillDisplayName = (name: string) =>
  request<BillDisplayName>("/users/me/bill-display-name", {
    method: "PUT",
    data: { name },
  });
